import { SubstitutionActions } from '../constants';
import { QueryParams } from 'src/types/grid';
import { SubstitutionFormData } from 'src/screens/General/screens/Substitutions/components/SubstitutionForm';
import { Dispatch } from 'redux';
import { SagaPromise } from './auth-actions';

export interface GetSubstitutionsAction {
    type: typeof SubstitutionActions.FETCH_SUBSTITUTIONS;
    payload: QueryParams;
}

export function getSubstitutions(params: QueryParams): GetSubstitutionsAction {
    return {
        type: SubstitutionActions.FETCH_SUBSTITUTIONS,
        payload: params,
    };
}

export interface GetSubstitutionAction {
    type: typeof SubstitutionActions.FETCH_SUBSTITUTION;
    payload: {
        id: string | number;
    };
}

export function getSubstitution(id: string | number): GetSubstitutionAction {
    return {
        type: SubstitutionActions.FETCH_SUBSTITUTION,
        payload: { id },
    };
}

export interface DeleteSubstitutionAction {
    type: typeof SubstitutionActions.DELETE_SUBSTITUTION;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteSubstitution(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteSubstitutionAction {
    return {
        type: SubstitutionActions.DELETE_SUBSTITUTION,
        payload: { id, onSuccess, onError },
    };
}

export interface PersistSubstitutionAction {
    type: typeof SubstitutionActions.PERSIST_SUBSTITUTION;
    payload: {
        data: SubstitutionFormData;
        // files: any;
        callbacks: SagaPromise<any>;
    };
}

export function persistSubstitution(
    data: SubstitutionFormData,
    // files: any,
    callbacks: SagaPromise<any>,
): PersistSubstitutionAction {
    return {
        type: SubstitutionActions.PERSIST_SUBSTITUTION,
        payload: {
            data,
            //files,
            callbacks,
        },
    };
}

export const asyncPersistSubstitution = (
    data: SubstitutionFormData,
    //  files: any,
    dispatch: Dispatch,
) => {
    return new Promise((resolve, reject) => {
        dispatch(
            persistSubstitution(
                data,
                //files,
                { resolve, reject },
            ),
        );
    });
};

export const asyncCreateFilesSubstitution = (id: number | string, files: any, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(createFilesSubstitution(id, files, { resolve, reject }));
    });
};

export interface CreateFilesSubstitutionAction {
    type: typeof SubstitutionActions.CREATE_FILES_SUBSTITUTION;
    payload: {
        id: number | string;
        files: any;
        callbacks: SagaPromise<any>;
    };
}

export function createFilesSubstitution(
    id: number | string,
    files: any,
    callbacks: SagaPromise<any>,
): CreateFilesSubstitutionAction {
    return {
        type: SubstitutionActions.CREATE_FILES_SUBSTITUTION,
        payload: {
            id,
            files,
            callbacks,
        },
    };
}

export interface GetFilesAction {
    type: typeof SubstitutionActions.FETCH_FILES_SUBSTITUTION;
    payload: {
        id: string | number;
    };
}

export function getFiles(id: string | number): GetFilesAction {
    return {
        type: SubstitutionActions.FETCH_FILES_SUBSTITUTION,
        payload: { id },
    };
}

export interface DeleteFileSubstitutionAction {
    type: typeof SubstitutionActions.DELETE_FILE_SUBSTITUTION;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteFileSubstitution(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteFileSubstitutionAction {
    return {
        type: SubstitutionActions.DELETE_FILE_SUBSTITUTION,
        payload: { id, onSuccess, onError },
    };
}

export type Actions =
    | GetSubstitutionsAction
    | GetSubstitutionAction
    | DeleteSubstitutionAction
    | PersistSubstitutionAction;
